import * as uuid from "uuid"
import { VideoEvent } from "brandguard/brandguard.video_pb"
import { Prediction } from "brandguard/brandguard.approval_pb"

export function zero(evt: Partial<VideoEvent> = {}): VideoEvent {
	return {
		id: uuid.NIL,
		account_id: uuid.NIL,
		brand_id: uuid.NIL,
		approved: Prediction.NONE,
		observation: Prediction.NONE,
		queue: "",
		confidence: 0.0,
		video_brand_uniqueness: 0.0,
		video_brand_voice: 0.0,
		video_sexually_explicit: 0.0,
		video_quality_general: 0.0,
		video_violence: 0.0,
		video_logo_detection: 0.0,
		video_font_detection: 0.0,
		video_background_colors: 0.0,
		video_lookandfeel_checks: 0n,
		video_lookandfeel_violations: 0n,
		video_lookandfeel_conformance: 0.0,
		updated_at: "",
		artifact_score: 0.0,
		artifact_match_description: "",
		artifact_match_training_id: "",
		duration_seconds: 0.0,
		video_ai_generated: 0.0,
		video_ai_generated_explanation: "",
		video_quality_general_explanation: "",
		...evt,
	}
}
